import { render } from "./CarNumber.vue?vue&type=template&id=81ab950a&scoped=true"
import script from "./CarNumber.vue?vue&type=script&lang=js"
export * from "./CarNumber.vue?vue&type=script&lang=js"

import "./CarNumber.vue?vue&type=style&index=0&id=81ab950a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81ab950a"]])

export default __exports__